import { SelectionMode } from '../grid/grid.model';

export class DialogConfig<D = any> {
  title?: string;
  maxwidth?: string;
  selectionMode: SelectionMode;
  data?: D;
}
